import React from 'react';
import one from '../Images/Client-01.png'
import two from '../Images/Client-02.png'
import three from '../Images/Client-03.png'
import four from '../Images/Client-04.png'
import five from '../Images/Client-05.png'
import Six from '../Images/Client-06.png'
import Seven from '../Images/Client-07.png'
import Eight from '../Images/Client-08.png'
import Nine from '../Images/Client-09.png'
import Ten from '../Images/Client-10.png'
function ClientSection() {
  return (
    <div className="bg-[#f3f5f1] text-[#222] font-roboto py-10 px-4 md:px-16 text-center">
        <div className="flex justify-center mt-[60px]">
  <div className="border-[1px] border-[#3f4a2f] max-w-[300px] w-full"></div>
</div>
      <div className="max-w-[1200px] mx-auto mt-[30px]">
        <div className="text-[#5a6537] text-[40px] font-medium " aria-label="Changing Lifestyle">
          Changing Lifestyle
        </div>
        <h1 className="text-[40px] font-bold mb-2">Our clients transformation</h1>
        <div className=" font-normal mb-10 text-[20px]">
          You Have To Work On Yourself Every Single Day!
        </div>

        {/* Cards */}
        <section aria-label="Clients transformation before and after photos" className="flex flex-wrap justify-center gap-8 mb-10">
          {/* Card 1 */}
          <article className="bg-[#e0e7c6] max-w-[360px] w-full flex flex-col">
            <div className="flex justify-center p-4">
              <img
                src={one}
                alt="Before image of a woman in pink traditional dress standing indoors"
                className="w-1/2 object-cover"
              />
              <img
                src={two}
                alt="After image of a woman in brown dress standing outdoors with balloons"
                className="w-1/2 object-cover"
              />
            </div>
            <div className="flex justify-around pb-7 text-[#5a6537] text-lg">
              <div className='font-medium text-[23px]'>Before</div>
              <div className='font-medium text-[23px]'>After</div>
            </div>
            <div className="bg-[#cfd9a3] font-bold text-[20px] py-3 text-[#222]">
              Total <strong>54kg </strong>Lose
            </div>
          </article>

          {/* Card 2 */}
          <article className="bg-[#e0e7c6] max-w-[360px] w-full flex flex-col">
            <div className="flex justify-center  p-4">
              <img
                src={three}
                alt="Before image of a man in beige shirt and dark pants standing outdoors"
                className="w-1/2 object-cover"
              />
              <img
                src={four}
                alt="After image of a man in blue suit standing indoors near a painting"
                className="w-1/2 object-cover"
              />
            </div>
             <div className="flex justify-around pb-7 text-[#5a6537] text-lg">
              <div className='font-medium text-[23px]'>Before</div>
              <div className='font-medium text-[23px]'>After</div>
            </div>
            <div className="bg-[#cfd9a3] font-bold text-[20px] py-3 text-[#222]">
              Total <strong>41kg </strong>Lose
            </div>
          </article>
      

          {/* Card 3 */}
          <article className="bg-[#e0e7c6] max-w-[360px] w-full flex flex-col">
            <div className="flex justify-center p-4">
              <img
                src={five}
                alt="Before image of a man in purple shirt and turban sitting indoors"
                className="w-1/2 object-cover"
              />
              <img
                src={Six}
                alt="After image of a man in pink polo shirt and turban standing indoors"
                className="w-1/2 object-cover"
              />
            </div>
           <div className="flex justify-around pb-12 text-[#5a6537] text-lg">
              <div className='font-medium text-[23px]'>Before</div>
              <div className='font-medium text-[23px]'>After</div>
            </div>
            <div className="bg-[#cfd9a3] font-bold text-[20px] py-3 text-[#222]">
              Total <strong>18kg </strong>Lose
            </div>
          </article>


          {/* Card 4 */}
          <article className="bg-[#e0e7c6] max-w-[360px] w-full flex flex-col">
            <div className="flex justify-center p-4">
              <img
                src={Seven}
                alt="Before image of a man in purple shirt and turban sitting indoors"
                className="w-1/2 object-cover"
              />
              <img
                src={Eight}
                alt="After image of a man in pink polo shirt and turban standing indoors"
                className="w-1/2 object-cover"
              />
            </div>
           <div className="flex justify-around pb-12 text-[#5a6537] text-lg">
              <div className='font-medium text-[23px]'>Before</div>
              <div className='font-medium text-[23px]'>After</div>
            </div>
            <div className="bg-[#cfd9a3] font-bold text-[20px] py-3 text-[#222]">
              Total <strong>19kg </strong>Lose
            </div>
          </article>


          {/* Card 5 */}
          <article className="bg-[#e0e7c6] max-w-[360px] w-full flex flex-col">
            <div className="flex justify-center p-4">
              <img
                src={Nine}
                alt="Before image of a man in purple shirt and turban sitting indoors"
                className="w-1/2 object-cover"
              />
              <img
                src={Ten}
                alt="After image of a man in pink polo shirt and turban standing indoors"
                className="w-1/2 object-cover"
              />
            </div>
           <div className="flex justify-around pb-12 text-[#5a6537] text-lg">
              <div className='font-medium text-[23px]'>Before</div>
              <div className='font-medium text-[23px]'>After</div>
            </div>
            <div className="bg-[#cfd9a3] font-bold text-[20px] py-3 text-[#222]">
              Total <strong>26kg </strong>Lose
            </div>
          </article>
        </section>

        <p className="text-[30px] font-normal mb-20">You are just a step away...</p>
        <button
          type="button"
          aria-label="Join Us Now"
          className="bg-[#6f7c3f] hover:bg-[#5a6537] text-white text-[22px] font-normal py-2.5 px-10 rounded-full cursor-pointer mb-16"
        >
          Join Us Now!
        </button>
      </div>
    </div>
  );
}

export default ClientSection;
